import { render, staticRenderFns } from "./ShowCategory.vue?vue&type=template&id=b8717c14&scoped=true&"
import script from "./ShowCategory.vue?vue&type=script&lang=js&"
export * from "./ShowCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8717c14",
  null
  
)

export default component.exports